/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_PlanInputs */

const en_for_whom_tag_plan = /** @type {(inputs: For_Whom_Tag_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training plan`)
};

const pl_for_whom_tag_plan = /** @type {(inputs: For_Whom_Tag_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan treningowy`)
};

/**
* | output |
* | --- |
* | "Training plan" |
*
* @param {For_Whom_Tag_PlanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_plan = /** @type {((inputs?: For_Whom_Tag_PlanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_PlanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_plan(inputs)
	return en_for_whom_tag_plan(inputs)
});